// import { createSelector } from 'reselect'
import { startsWith, cloneDeep } from 'lodash';
import { vtparammap } from './model'

export const getIsFetchingVtParamMap = (state, props) => state.vtparammap.params.isFetching;
export const getIsVtParamMapFetched = (state, props) => state.vtparammap.params.vtParamMapFetched;
export const getVtParamMapList = (state, prop) => state.vtparammap.byId
export const getIsSearching = (state, props) => state.vtparammap.params.isSearching;
export const getIsSearchFetched = (state, props) => state.vtparammap.params.searchFetched;
export const getSearchResults = (state, prop) => state.vtparammap.searchResults

export const getDataSetOnOpenEdit = (state, prop) => state.vtparammap.dataSetOnOpenEdit

export const filters = (state, prop) => state.vtparammap.filterResults;
export const getDeleteStatus = (state, prop) => state.vtparammap.deleteStatus
export const getDelFetched = (state, prop) => state.vtparammap.params.isDelFetched
export const getNotification = (state, id) => state.vtparammap.notifications[id]

export const getVtParamMap = (state, props) => {
    if (props.match.path === '/vtparam_map/create') {
        return vtparammap()
    }
    if (props.match.path === '/vtparam_map/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.vtparammap.byId[id]);
        if (!obj) {
            return vtparammap()
        }
        obj.cid = obj.cid ? parseInt(obj.cid, 10) : null
        obj.segid = obj.segid ? parseInt(obj.segid, 10) : null
        return obj
    }
}

export const getParams = (state, props) => {
    const params = {}
    if (startsWith(state.router.location.pathname, '/vtparam_map/create')) {
        params.title = state.vtparammap.params.createTitle
        params.submitButtonText = state.vtparammap.params.createSubmitButtonText
    };
    if (startsWith(state.router.location.pathname, '/vtparam_map/edit/')) {
        params.title = state.vtparammap.params.editTitle
        params.submitButtonText = state.vtparammap.params.editSubmitButtonText
    };
    return params
}